var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable no-use-before-define */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import hoistStatics from 'hoist-non-react-statics';
import hoistReactInstanceMethods from 'hoist-react-instance-methods';
import shallowCompare from 'react-addons-shallow-compare';
import Emitter from 'emit-lite';
import is from 'core-js/library/fn/object/is';

var REF = 'ref';

var isFunction = function isFunction(t) {
	return typeof t === 'function';
};
var isNotFunction = function isNotFunction(t) {
	return !isFunction(t);
};

var forEach = function forEach(object, iterator) {
	return Object.keys(object).forEach(function (key) {
		return iterator(object[key], key);
	});
};

var ensure = function ensure(validator, errorMessage) {
	return function (val) {
		if (!validator(val)) {
			throw new Error(errorMessage);
		}
		return val;
	};
};

var ensureValue = ensure(isNotFunction, 'Value should NOT be a function.');

export var Wormhole = function (_Emitter) {
	_inherits(Wormhole, _Emitter);

	function Wormhole(initialValue) {
		_classCallCheck(this, Wormhole);

		var _this = _possibleConstructorReturn(this, (Wormhole.__proto__ || Object.getPrototypeOf(Wormhole)).call(this));

		_this._val = ensureValue(initialValue);
		return _this;
	}

	_createClass(Wormhole, [{
		key: 'get',
		value: function get() {
			this.emit('get');
			return this._val;
		}
	}, {
		key: 'set',
		value: function set(value) {
			var prevValue = this._val;
			this._val = ensureValue(value);
			this.emit('set', value, prevValue);
			if (!is(prevValue, value)) {
				this.emit('change', value, prevValue);
			}
		}
	}, {
		key: 'hoc',
		value: function hoc(name, options) {
			var _this2 = this;

			return connect(function () {
				return _defineProperty({}, name, _this2);
			}, null, options);
		}
	}]);

	return Wormhole;
}(Emitter);

Wormhole.connect = connect;

var ContextTyper = function () {
	function ContextTyper(name) {
		_classCallCheck(this, ContextTyper);

		this._name = name;
	}

	_createClass(ContextTyper, [{
		key: 'toType',
		value: function toType() {
			return _defineProperty({}, this._name, PropTypes.object);
		}
	}, {
		key: 'toValue',
		value: function toValue(reactContext) {
			return reactContext[this._name];
		}
	}]);

	return ContextTyper;
}();

export function ensureWormholeValue(val) {
	var isValid = val instanceof Wormhole;
	return isValid ? val : new Wormhole(val);
}

var noop = function noop() {
	return {};
};

export function connect() {
	var mapProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
	var options = arguments[1];

	return function hoc(WrappedComponent) {
		var _ref3 = options || {},
		    _ref3$contextType = _ref3.contextType,
		    contextType = _ref3$contextType === undefined ? 'wormholes' : _ref3$contextType,
		    _ref3$isPure = _ref3.isPure,
		    isPure = _ref3$isPure === undefined ? true : _ref3$isPure,
		    _ref3$withRef = _ref3.withRef,
		    withRef = _ref3$withRef === undefined ? false : _ref3$withRef,
		    hoistMethods = _ref3.hoistMethods,
		    _ref3$getInstance = _ref3.getInstance,
		    getInstance = _ref3$getInstance === undefined ? function (instance) {
			return instance.getWrappedInstance();
		} : _ref3$getInstance;

		var contextTyper = new ContextTyper(contextType);

		var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

		var refs = withRef ? { ref: REF } : {};

		var ConnectWormhole = function (_Component) {
			_inherits(ConnectWormhole, _Component);

			function ConnectWormhole() {
				_classCallCheck(this, ConnectWormhole);

				return _possibleConstructorReturn(this, (ConnectWormhole.__proto__ || Object.getPrototypeOf(ConnectWormhole)).apply(this, arguments));
			}

			_createClass(ConnectWormhole, [{
				key: 'componentWillMount',
				value: function componentWillMount() {
					var _this4 = this;

					var context = this.context;


					var state = {};
					var methods = {};
					var tempMethods = {};
					var wormholesFromCtx = contextTyper.toValue(context);
					var wormholes = {
						$self: this,
						$wormholes: wormholesFromCtx
					};
					var props = isFunction(mapProps) ? mapProps(wormholesFromCtx, this) : mapProps || wormholesFromCtx;

					this._unsubscribes = [];

					forEach(props, function (value, prop) {
						if (isFunction(value)) {
							return tempMethods[prop] = value;
						}
						var wormhole = wormholes[prop] = ensureWormholeValue(value);
						state[prop] = wormhole.get();
						_this4._unsubscribes.push(wormhole.on('change', function (nextValue) {
							_this4.setState(_defineProperty({}, prop, nextValue));
						}));
					});

					forEach(tempMethods, function (method, prop) {
						return methods[prop] = method.bind(wormholes);
					});

					this.state = state;
					this.methods = methods;
				}
			}, {
				key: 'componentWillUnmount',
				value: function componentWillUnmount() {
					this._unsubscribes.forEach(function (unsubscribe) {
						return unsubscribe();
					});
				}
			}, {
				key: 'shouldComponentUpdate',
				value: function shouldComponentUpdate() {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					return !isPure || shallowCompare.apply(undefined, [this].concat(args));
				}
			}, {
				key: 'getWrappedInstance',
				value: function getWrappedInstance() {
					if (!withRef) {
						console.warn('Could not invoke `getWrappedInstance` without `withRef` options');
						return null;
					}
					return this.refs[REF];
				}
			}, {
				key: 'render',
				value: function render() {
					var props = this.props,
					    state = this.state,
					    methods = this.methods;


					return React.createElement(WrappedComponent, _extends({}, props, state, methods, refs));
				}
			}]);

			return ConnectWormhole;
		}(Component);

		ConnectWormhole.displayName = 'ConnectWormhole(' + displayName + ')';
		ConnectWormhole.WrappedComponent = WrappedComponent;
		ConnectWormhole.contextTypes = contextTyper.toType();


		if (hoistMethods) {
			if (!withRef) {
				console.warn('Could not use `hoistMethods` without setting `withRef` as `true`');
			} else {
				hoistReactInstanceMethods(ConnectWormhole, getInstance, hoistMethods);
			}
		}

		return hoistStatics(ConnectWormhole, WrappedComponent);
	};
}